import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { FEATURE } from '~/common/enums/feature.enum';

import { useTreatments } from '../../hooks/useTreatments';
import { Banner, BannerType } from '../Banner/Banner';

// Only these show the banner: Mixpanel's Dynamic Config control ('$dynamic_config_disabled') or any
// unknown treatment must not put a banner in front of every user. Matches splash-microfrontends.
const ENABLED_TREATMENTS = new Set(['on', 'test']);

export function MaintenanceBanner() {
  const { t } = useTranslation('common');
  const { isSettled, treatments } = useTreatments([FEATURE.SHOW_MAINTENANCE_BANNER]);
  const { treatment, config } = treatments[FEATURE.SHOW_MAINTENANCE_BANNER];
  const isEnabled = ENABLED_TREATMENTS.has(treatment);

  if (!isSettled || !isEnabled) {
    return null;
  }

  let message: string = t('banner.maintenanceBanner.message');
  let type: BannerType = BannerType.INFO;
  if (!process.env.STORYBOOK) {
    message = config?.message ?? message;
    type = config?.type ?? type;
  }

  if (!message) {
    return null;
  }

  return <Banner message={message} type={type} allowClose />;
}
